{
    "CodeList_Column_Description": "Description",
    "CodeList_Column_Code": "Code",
    "CodeList_Column_Type": "Type",
    "CodeList_Column_TelSys": "Telephony Server",
    "CodeList_Column_Partition": "Partition",
    "CodeList_Partition_Any": "Any",
    "CodeList_Scope_All": "All",
    "CodeList_Scope_ServiceWide": "Service wide",
    "CodeList_Scope_SystemWide": "System wide",
    "CodeList_Scope_Detached": "Detached",
    "CodeList_Type_All": "All",
    "CodeList_Type_Account": "Account",
    "CodeList_Type_ACD_NotAvailable": "ACD Not Available",
    "CodeList_Scope_Label": "Scope",
    "CodeList_Type_Label": "Type",
    "CodeList_Change_AnyPartitionNotSupported": "Codes in \"Any\" partition cannot be edited or viewed here. Filter the list by a specific partition to change or view a code.",
    "NAME": "CodeListLanguage"
}
